import { resolveAssetPath } from '../../utils/asset-util';
import { axiosAPIInstance as axios } from '../../axios-config';
import { applyFont } from '../../utils/fonts';

const state = {
  signInConfig: {
    // metadata
    _id: '',
    name: '',
    default: false,
    enableRegistrationNotifications: false,
    registrationEmailList: '',
    domain: '',

    // settings
    tabText: 'Loading...',
    helpUrl: 'https://redmeru.zendesk.com',
    faqUrl: 'https://redmeru.zendesk.com',
    corporateSiteUrl: 'https://redmerproductions.com',
    defaultSettings: {
      displayCorporateSite: true,
      displayHelp: true,
      displayFAQ: true,
      displayRedmerBrand: true
    },
    roleOverrides: {},

    navbarLogo: '',
    backgroundImage: '',
    midsectionImage: '',
    midsectionText: '',

    brandPrimaryColor: 'rgba(0, 0, 0, 0)',
    midsectionTextColor: 'rgba(0, 0, 0, 0)',
    signinBackgroundColor: 'rgba(255, 255, 255, 1)',
    signinTextColor: 'rgba(33, 33, 33, 1)',
    font: 'Aller'
  },
  activeSigninRole: ''
};

const getters = {
  activeSignInConfig(state) {
    return state.signInConfig;
  },
  activeToggleSettings(state) {
    const config = state.signInConfig;
    console.log('evaluating signin toggle settings...');
    if (state.activeSigninRole && config.roleOverrides[state.activeSigninRole]) {
      console.log('overriding');
      return config.roleOverrides[state.activeSigninRole];
    }
    console.log('default');
    return config.defaultSettings;
  }
};

const fallbackConfig = {
  _id: '60918f2a0d6124001b2a5e10',
  defaultSettings: {
    displayCorporateSite: true,
    displayHelp: true,
    displayFAQ: true,
    displayRedmerBrand: true
  },
  default: true,
  domain: 'bladeplatform.us',
  tabText: 'B.L.A.D.E. PLATFORM',
  helpUrl: 'https://redmeru.zendesk.com',
  faqUrl: 'https://redmeru.zendesk.com',
  corporateSiteUrl: 'https://redmerproductions.com',
  brandPrimaryColor: 'rgba(0, 0, 0, 1)',
  midsectionTextColor: 'rgba(255, 255, 255, 1)',
  font: 'Tahoma',
  name: 'bladeplatform.us',
  roleOverrides: {},
  environment: {
    $oid: '6091945f0d6124001b2a5e11'
  },
  navbarLogo: 'https://assets.redmeru.com/eai/blade_logos/BLADE-FullWordmark-dark.jpg',
  backgroundImage: 'https://assets.redmeru.com/eai/ui/customer/Blade_LoginBG_1.png',
  midsectionImage: 'https://assets.redmeru.com/eai/blade_logos/BLADE-Bullets-dark.jpg',
  midsectionText: 'ERROR: No domain branding data has been loaded.  Please report this error to an administrator.',
  updated: {
    $date: '2021-12-06T22:05:19.790Z'
  },
  __v: 0,
  enableRegistrationNotifications: true
};

const mutations = {
  setSignInRole(state, data) {
    state.activeSigninRole = data;
  },
  setActiveSignInConfig(state, data) {
    if (!data) {
      // eslint-disable-next-line no-param-reassign
      data = fallbackConfig;
    }
    state.signInConfig = data;
    if (data != null && data.name != null) {
      document.documentElement.style.setProperty(
        '--signInBackground', `url(${resolveAssetPath(data.backgroundImage || 'LoginBG.jpg', 'ui/customer')})`
      );
      document.documentElement.style.setProperty(
        '--signInTextColor', data.midsectionTextColor || 'black'
      );
      document.documentElement.style.setProperty(
        '--signInTitleColor', data.signinTextColor || '#222222'
      );
      applyFont(data.font);
    }
  }
};

const actions = {
  async createSignInConfig(_, config) {
    if (config.uniqueIdClass !== undefined && config.uniqueIdClass !== null && config.uniqueIdClass.trim() === '') {
      config.uniqueIdClass = null;
    }
    const response = await axios.post('/blade/signin', config);
    return response.data.config;
  },
  async getSignInConfigs() {
    const response = await axios.get('/blade/signin');
    return response.data.configs;
  },
  async getSignInConfig(_, { signinConfigId }) {
    const { data } = await axios.get(`/blade/signin/${signinConfigId}`);
    return data;
  },
  async getActiveSignInConfig(context) {
    const endpoint = '/blade/signinActive';
    const { data } = await axios.get(endpoint);
    context.commit('setActiveSignInConfig', data.config);
    return data.config;
  },
  async updateSignInConfig(_, config) {
    if (config.uniqueIdClass !== undefined && config.uniqueIdClass !== null && config.uniqueIdClass.trim() === '') {
      config.uniqueIdClass = null;
    }
    const response = await axios.patch(`/blade/signin/${config._id}`, config);
    return response.data.config;
  },
  async deleteSignInConfig(_, { signinConfigId, _id }) {
    const did = signinConfigId || _id;
    const response = await axios.delete(`/blade/signin/${did}`);
    return response.data.config;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/signin-config.js